import axios from "axios";
import {
  EVENT_NAME_FAIL,
  RECOMMENDED_UNIVERSITY_FAILED,
  RECOMMENDED_UNIVERSITY_LIST_FAILED,
  RECOMMENDED_UNIVERSITY_LIST_REQ,
  RECOMMENDED_UNIVERSITY_LIST_SUCCESS,
  RECOMMENDED_UNIVERSITY_REQ,
  RECOMMENDED_UNIVERSITY_SUCCESS,
  UNIVERSITY_ATTENDED_COUNT_FAILED,
  UNIVERSITY_ATTENDED_COUNT_REQ,
  UNIVERSITY_ATTENDED_COUNT_SUCCESS,
} from "../constants/eventConstants";

let Api = process.env.REACT_APP_SEARCH_API_URL2;

export const UniversityListRec = (ContactId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: RECOMMENDED_UNIVERSITY_LIST_REQ,
    });

    const {
      guestUserLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + localStorage.getItem("guestInfo"),
      },
    };

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await axios.get(
        `${Api}/event/event/activity/${ContactId}`,
        config
      );

      const dt = data.Result;
      if (typeof dt == "string") {
        dispatch({
          type: RECOMMENDED_UNIVERSITY_LIST_FAILED,
          payload: dt,
        });
      } else {
        dispatch({
          type: RECOMMENDED_UNIVERSITY_LIST_SUCCESS,
          payload: data.Result[0],
        });
      }
    } else {
      dispatch({
        type: RECOMMENDED_UNIVERSITY_LIST_FAILED,
        payload: "Not attended !",
      });
    }
  } catch (error) {
    const message =
      error.response && error.response.data.Result
        ? error.response.data.Result
        : error.message;
    dispatch({
      type: RECOMMENDED_UNIVERSITY_LIST_FAILED,
      payload: message,
    });
  }
};

export const UniversityListUpdate =
  (inputJson, ContactId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: RECOMMENDED_UNIVERSITY_REQ,
      });

      const {
        guestUserLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + localStorage.getItem("guestInfo"),
        },
      };

      if (userInfo != undefined || userInfo != "" || userInfo != null) {
        const { data } = await axios.post(
          `${Api}/event/event/activity/${ContactId}`,
          inputJson,
          config
        );

        dispatch({
          type: RECOMMENDED_UNIVERSITY_SUCCESS,
          payload: data.Result,
        });
      } else {
        dispatch({
          type: RECOMMENDED_UNIVERSITY_FAILED,
          payload: "Not attended !",
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message;
      dispatch({
        type: RECOMMENDED_UNIVERSITY_FAILED,
        payload: message,
      });
    }
  };

export const Get_Contact_Activity = (eventId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: UNIVERSITY_ATTENDED_COUNT_REQ,
    });

    const {
      guestUserLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + localStorage.getItem("guestInfo"),
      },
    };

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await axios.get(
        `${Api}/guestactivity/event/contact/important/${eventId}`,
        config
      );

      const dt = data.Result;
      if (typeof dt == "string") {
        dispatch({
          type: UNIVERSITY_ATTENDED_COUNT_FAILED,
          payload: dt,
        });
      } else {
        dispatch({
          type: UNIVERSITY_ATTENDED_COUNT_SUCCESS,
          payload: data.Result,
        });
      }
    } else {
      dispatch({
        type: UNIVERSITY_ATTENDED_COUNT_FAILED,
        payload: "No Record !",
      });
    }
  } catch (error) {
    const message =
      error.response && error.response.data.Result
        ? error.response.data.Result
        : error.message;
    dispatch({
      type: UNIVERSITY_ATTENDED_COUNT_FAILED,
      payload: message,
    });
  }
};

// /guestactivity/contact/important/:eventId
